import { SIZE_OF_EMPTY_ARRAY, ZERO } from '@/constants/common';
import { FEATURE_TYPE, PIN_ICON_ANY, SURFACE_ANY } from '@/constants/features';
import { openBioEntityDrawerById, openCommentDrawerById } from '@/redux/drawer/drawer.slice';
import { AppDispatch } from '@/redux/store';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';
import { FeatureLike } from 'ol/Feature';
import { Comment } from '@/types/models';

interface HandleFeaturesClickResult {
  shouldBlockCoordSearch: boolean;
}

export const handleFeaturesClick = (
  features: FeatureLike[],
  dispatch: AppDispatch,
  comments: Comment[],
): HandleFeaturesClickResult => {
  const pinFeatures = features.filter(feature => PIN_ICON_ANY.includes(feature.get('type')));
  const surfaceFeatures = features.filter(feature => SURFACE_ANY.includes(feature.get('type')));
  const textFeatures = features.filter(feature => feature.get('type') === FEATURE_TYPE.TEXT_MARKER);
  const imageFeatures = features.filter(
    feature => feature.get('type') === FEATURE_TYPE.IMAGE_MARKER,
  );
  const lineFeatures = features.filter(feature => feature.get('type') === FEATURE_TYPE.LINE_MARKER);
  const polygonFeatures = features.filter(
    feature => feature.get('type') === FEATURE_TYPE.POLYGON_MARKER,
  );
  const shouldBlockCoordSearch = pinFeatures.length > SIZE_OF_EMPTY_ARRAY;
  pinFeatures.forEach(pin => {
    const pinId = pin.get('id') as string | number;
    PluginsEventBus.dispatchEvent('onPinIconClick', { id: pinId });
    if (pin.get('type') === FEATURE_TYPE.PIN_ICON_BIOENTITY) {
      dispatch(openBioEntityDrawerById(pinId));
    } else if (pin.get('type') === FEATURE_TYPE.PIN_ICON_COMMENT) {
      const filteredComments = comments.filter(comment => comment.id === pinId);
      if (filteredComments.length > ZERO) {
        dispatch(openCommentDrawerById(Number(pinId)));
      } else {
        throw new Error(`Cannot find comment with id ${pinId}`);
      }
    }
  });

  surfaceFeatures.forEach(surface => {
    const surfaceId = surface.get('id') as string | number;
    PluginsEventBus.dispatchEvent('onSurfaceClick', { id: surfaceId });
  });

  textFeatures.forEach(text => {
    PluginsEventBus.dispatchEvent('onTextClick', { id: text.get('id') as string });
  });

  imageFeatures.forEach(image => {
    PluginsEventBus.dispatchEvent('onImageClick', { id: image.get('id') as string });
  });

  lineFeatures.forEach(line => {
    PluginsEventBus.dispatchEvent('onLineClick', { id: line.get('id') as string });
  });

  polygonFeatures.forEach(polygon => {
    PluginsEventBus.dispatchEvent('onPolygonClick', { id: polygon.get('id') as string });
  });

  return {
    shouldBlockCoordSearch,
  };
};
